import { render, staticRenderFns } from "./PlaceInfoLayer.vue?vue&type=template&id=1167d044&scoped=true&"
import script from "./PlaceInfoLayer.vue?vue&type=script&lang=js&"
export * from "./PlaceInfoLayer.vue?vue&type=script&lang=js&"
import style0 from "@/styles/PlaceInfoLayer.scss?vue&type=style&index=0&id=1167d044&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1167d044",
  null
  
)

export default component.exports